import {BehaviorSubject} from "rxjs";
/**
 * Komunikacja między SessionModalComponent a App.jsx
 * @type {BehaviorSubject<null>}
 */
const idleTimerBehaviorSubject = new BehaviorSubject(null);

/**
 * Komunikacja miedzy SessionModalComponent a LoginModalComponent
 * @type {BehaviorSubject<null>}
 */
const loginModalBehaviorSubject = new BehaviorSubject(null);

/**
 * Obsługa komunikatów dotyczących wygaśnięcia sesji oraz aktywacji modalnego okna logowania.
 * @type {{idleTimerTimeout: (function(*=): void), idleTimerService: (function(): Observable<null>)}}
 */
export const sessionMessageService = {
    idleTimerTimeout: item => idleTimerBehaviorSubject.next(item),
    idleTimerService: () => idleTimerBehaviorSubject.asObservable(),

    loginModalDialog: item => loginModalBehaviorSubject.next(item),
    loginModalService: () => loginModalBehaviorSubject.asObservable()
};